import "./choose-profession.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _component = require("../../_utils/component");

var _vueNormalizeComponent = _interopRequireDefault(require("../../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MAX_NUM = 3;
var __vue_script__ = {
  name: (0, _component.createComponentName)('choose-profession'),
  mixins: [_component.componentMixin],
  props: {
    allOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    chosenOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data() {
    return {
      transformedOptions: this.transform(this.allOptions, this.chosenOptions)
    };
  },

  computed: {
    chosenOptionsNow() {
      return this.transformedOptions.filter(function (option) {
        return option.chosen;
      });
    }

  },
  methods: {
    transform(all, chosen) {
      return all.map(function (option) {
        var value = chosen.find(function (chosenOption) {
          return chosenOption.preference_id === option.id;
        });

        if (value) {
          option.chosen = true;
        }

        return (0, _assign.default)({}, option);
      });
    },

    toggleChooseProfession(item) {
      if (this.chosenOptionsNow.length >= MAX_NUM && !item.chosen) return;
      this.$set(item, 'chosen', !item.chosen);
    },

    comfirmChoose() {
      if (this.chosenOptionsNow.length === 0) return;
      var chosenOptionsNow = this.chosenOptionsNow;
      var chosenOptions = this.chosenOptions;
      var params = {};
      var updateRecords = chosenOptions.map(function (option, index) {
        if (chosenOptionsNow[index]) {
          return {
            id: option.recordId,
            preference_id: chosenOptionsNow[index].id,
            type: 'profession'
          };
        }

        return {
          id: option.recordId,
          deleted: 1,
          type: 'profession'
        };
      });
      params.update = updateRecords;

      if (chosenOptionsNow.length > chosenOptions.length) {
        var createRecords = chosenOptionsNow.slice(chosenOptions.length).map(function (option) {
          return {
            preference_id: option.id,
            type: 'profession'
          };
        });
        params.create = createRecords;
      }

      this.$emit('chooseOption', params);
    },

    showIndustryOptions() {
      this.$emit('showIndustryOptions');
    },

    isDisabled(chosen) {
      if (!chosen && this.chosenOptionsNow.length >= MAX_NUM) {
        return true;
      }

      return false;
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("section", {
    class: _vm.bem()
  }, [_c("header", {
    class: _vm.bem("header")
  }, [_c("div", {
    class: _vm.bem("header-main")
  }, [_vm._v("仅需两步，就可获得更精准的模板推荐")]), _vm._v(" "), _c("div", {
    class: _vm.bem("header-sub")
  }, [_vm._v("您的职业是？\n        "), _c("span", {
    class: _vm.bem("header-sub-tip")
  }, [_vm._v("最多选择3个职业")])])]), _vm._v(" "), _c("main", [_c("ul", {
    class: _vm.bem("option-list")
  }, _vm._l(_vm.transformedOptions, function (option) {
    return _c("li", {
      key: option.id,
      class: _vm.bem("option-item"),
      on: {
        click: function click($event) {
          return _vm.toggleChooseProfession(option);
        }
      }
    }, [_c("button", {
      class: [option.chosen ? "chosen" : "", _vm.isDisabled(option.chosen) ? "disabled" : "", _vm.bem("option-btn")]
    }, [_c("span", [_vm._v(_vm._s(option.name))])])]);
  }), 0)]), _vm._v(" "), _c("footer", {
    class: _vm.bem("footer")
  }, [_c("button", {
    class: _vm.bem("previous-btn"),
    on: {
      click: _vm.showIndustryOptions
    }
  }, [_c("span", [_vm._v("上一步")])]), _vm._v(" "), _c("button", {
    class: [_vm.chosenOptionsNow.length ? "" : "disabled", _vm.bem("complete-btn")],
    on: {
      click: _vm.comfirmChoose
    }
  }, [_c("span", [_vm._v("完成定制")])])])]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default2 = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default2;